module.exports = __webpack_public_path__ + "static/img/11.199be3fb.gif";